module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAD1BMVEX////VM0bOESbniJP////+7S8OAAAAAnRSTlPU+CChtw0AAAAxSURBVEjH7dWxDQAwCMAwqPoA/z/bG0B0c3bPyYput09OIAiCIMj+XywJQRAE+UEGPWWqAM74SM60AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/id.png
// module id = 2ipl
// module chunks = 0